<template>
    <div :class="{ pointer: promotionIdExists }">
        <icon :icon-name="icoName" medium />
    </div>
</template>

<script>
import { defineComponent } from 'vue';
import { get, groupBy, isEmpty } from 'lodash';
import promotionErrorSeverities from '@enums/promotion-error-severities';
import notificationTypes from '@enums/notification-types';
import { mapGetters } from 'vuex';

export default defineComponent({
    computed: {
        ...mapGetters('promotions', ['getPromotionNotifications']),
        renderIcon() {
            // conditional icon render based on row data
            if (this.params.renderFunction) {
                return this.params.renderFunction(this.params);
            }
            return true;
        },
        executionErrors() {
            return this.params.data?.executionErrors || [];
        },
        forecastingErrors() {
            return this.params.data?.forecastingErrors || [];
        },
        promotionIdExists() {
            return !!this.params.data?.promotionId;
        },
        inToolValidations() {
            if (!isEmpty(this.params.data?.inToolValidations)) {
                return groupBy(this.params.data.inToolValidations, 'severity');
            }
            if (this.promotionIdExists) {
                const notificationKey = notificationTypes.ruleValidationError;
                const notification = this.getPromotionNotifications({
                    promotionId: this.params.data.promotionId,
                    notificationKey,
                });
                if (notification && notification.length) {
                    const ruleValidationTypes = get(
                        notification[0],
                        'details.ruleValidationTypes',
                        []
                    );
                    return groupBy(ruleValidationTypes, 'severity');
                }
            }
            return null;
        },
        isErros() {
            if (get(this.inToolValidations, 'error', []).length) {
                return true;
            }
            return (this.executionErrors || []).some(
                e => e.errorSeverity.toLowerCase() === promotionErrorSeverities.ERROR.toLowerCase()
            );
        },
        isWarnings() {
            if (this.forecastingErrors && this.forecastingErrors.length) {
                return true;
            }
            if (get(this.inToolValidations, 'warning', []).length) {
                return true;
            }
            return (this.executionErrors || []).some(
                e =>
                    e.errorSeverity.toLowerCase() === promotionErrorSeverities.WARNING.toLowerCase()
            );
        },
        isInfos() {
            return get(this.inToolValidations, 'warning', []).length;
        },
        icoName() {
            if (this.isErros) {
                return 'custom:red-error-triangle';
            }
            if (this.isWarnings) {
                return 'custom:orange-warning-circle';
            }
            if (this.isInfos) {
                return 'custom:grey-warning-square';
            }
            return null;
        },
    },
});
</script>

<style lang="scss" scoped>
.pointer {
    &:hover {
        cursor: pointer;
    }
}
</style>
